import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";

export default async function openClientById(id: string) {
    let p: OperatorApplicationApi.OperatorGetUserdataByIdOpenApiModel = {
        id
    };
    let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorGetUserdataByCcResultOpenApiModel>({
        url: "/buddyList/getUserdataById",
        p
    })).send();
    if (!result.showMessageOnError()) {
        let data = result.data;
        let client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel = data.client;
        if (client) {
            OperatorApplicationBuddyList.addClientAndOpenByUserdata(client);
            return true;
        }
    }
    return false;
}